import bkBtn2 from 'src/assets/images/user-mobile/BackBtn2.svg';
import { useNavigate } from 'react-router-dom';
import { Flex } from 'src/styles/user-mobile/OverviewStyleMobile';
import styled from 'styled-components';
import { BkBtn } from 'src/styles/user-mobile/TopFixedBarStyle';

function TopFixedBarParking() {
  const navigate = useNavigate();

  return (
    <TopFixedBlock>
      <StyledTopFixedBar>
        <Flex style={{ marginLeft: '16px' }}>
          <BkBtn onClick={() => navigate('/')} src={bkBtn2} />
        </Flex>
      </StyledTopFixedBar>
    </TopFixedBlock>
  );
}

export default TopFixedBarParking;

const TopFixedBlock = styled.div`
  width: 100%;
  position: fixed;
  z-index: 100;
  flex-direction: column;
`;

const StyledTopFixedBar = styled.div`
  position: fixed;
  width: 100%;
  height: 52px;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  h1 {
    color: #111;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
  }

  background-color: white;
  color: var(--Font-02_black, #111);

  button {
    display: inline-flex;
    padding: 8px 12px;
    justify-content: center;
    align-items: center;

    color: ${({ theme }) => theme.colors.fontColor};

    border-radius: 6px;
    background: ${({ theme }) => theme.colors.subColor};

    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: -0.35px;

    margin-right: 16px;
  }
`;
